// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"SearchBar_cardsContainer__1u5Z-","form__submit":"SearchBar_form__submit__ybOPE","form__search":"SearchBar_form__search__20bcL"};